import { api } from '../index';

export const get = () => api.get('/quiz');

export const save = data => api.post('/quiz/answer', data);
